import httpClient from './httpClient';

const accountService = {
    recoverByEmail(email) {
        return httpClient.post(`/api/adv/account/password/recovery?${httpClient.buildParams(email)}`)
    },
    activateAccount(data) {
        return httpClient.post('/api/adv/account/activation', data);
    },
    allocate(data) {
        return httpClient.post('/api/adv/account/allocate', data);
    }
}

export default accountService;